export default "__VITE_ASSET__DsTXdJOS__"